import { diagramHelpers } from '@/mixins/diagramHelpers'

export const formatCardKey = (cardTitle) => {
  if (!cardTitle || typeof cardTitle !== 'string') {
    return ''
  }
  return cardTitle.replace(/\//g, '').replace(/\s+/g, '-').toLowerCase()
}

export const adjustEnding = (word, quant) => {
  if (!word) {
    return ''
  }
  if (quant > 1 && word.charAt(word.length - 1) === 'y') {
    const str = word.substring(0, word.length - 1)
    return str + 'ies'
  }
  if (quant > 1 && word.charAt(word.length - 1) !== 's') {
    return word + 's'
  }
  if (quant === 1 && word.charAt(word.length - 1) === 's') {
    return word.substring(0, word.length - 1)
  }
  return word
}

export const removeTrailingDot = (word) => {
  if (word && word.charAt(word.length - 1) === '.') {
    return word.substring(0, word.length - 1)
  }
  return word || ''
}

export const flattenMultilineString = (str) => {
  if (typeof str !== 'string') {
    return String(str)
  }

  return str
    .split('\n')
    .map(line => line.trim())
    .filter(line => line.length > 0)
    .join(' ')
    .trim()
}

export const getCommandName = (currentStepObject, cardTypes) => {
  const commandCardType = diagramHelpers.methods.getCommandCardType(cardTypes)

  if (!commandCardType) {
    return ''
  }

  const commandCardKey = formatCardKey(commandCardType.title)
  return currentStepObject[commandCardKey]?.[0]?.replace(/<\/?p>/g, '')
}

export const getAggregateName = (currentStepObject, cardTypes) => {
  const aggregateCardType = diagramHelpers.methods.getAggregateCardType(cardTypes)

  if (!aggregateCardType) {
    return ''
  }

  const aggregateCardKey = formatCardKey(aggregateCardType.title)
  return currentStepObject[aggregateCardKey]?.[0]?.replace(/<\/?p>/g, '')
}
